import PropTypes from 'prop-types';
import React from 'react';
import { capitalizeText } from '../../Pod/podUtils';
import { AvailabilityLocationStyles } from './AvailabilityLocation.style';

export const AvailabilityLocation = ({ comunaName }) => {
  return (
    <>
      <div className="delivery-option-location">
        <p className="delivery-location-text">
          Entrega en <span>{capitalizeText(comunaName)}</span>
        </p>
      </div>
      <style jsx>{AvailabilityLocationStyles}</style>
    </>
  );
};

AvailabilityLocation.propTypes = {
  comunaName: PropTypes.string.isRequired,
};
